import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loadWeekdaysRequested } from 'store/papers/papersSlice';

export function useLoadWeekdays() {
  const dispatch = useDispatch();

  const onLoadWeekdays = useCallback(() => {
    dispatch(loadWeekdaysRequested({}));
  }, [dispatch]);

  useEffect(() => {
    onLoadWeekdays();
  }, [onLoadWeekdays]);

  return { onLoadWeekdays };
}
